/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    pairs: {
        menu: {
            index: 'جفت‌ارزها',
            create: 'جدید',
            list: 'جفت‌ارزها'
        },
        table_titles: {
            id: 'شناسه',
            symbol: 'نماد',
            exchange: 'صرافی',
            bid_rate: 'قیمت خرید',
            ask_rate: 'قیمت فروش',
            is_api_enabled: 'وضعیت API',
            is_rate_ok: 'وضعیت نرخ',
            is_secondary: 'جفت‌ارز ثانویه',
            slippage_amount: 'لغزش (دلار)',
            slippage_percent: 'لغزش (%)',
            updated_at: 'آخرین به‌روزرسانی',
            decimals: 'اعشار',
            setting: 'ویرایش / حذف',
        },
        edit: 'ویرایش جفت‌ارز'
    }
}
